import { render, staticRenderFns } from "./RecentLow.vue?vue&type=template&id=f70995b4&"
import script from "./RecentLow.vue?vue&type=script&lang=js&"
export * from "./RecentLow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports